const eventData = [
  {
    id: 1,
    event_name: "Iftari awajon with potho shishu in Dhaka",
    status: "up-comming",
    location: "Dhaka",
    time: "06:00 pm",
  },
  {
    id: 2,
    event_name: "Ek bela ahar in Dhaka",
    status: "on-going",
    location: "Dhaka",
    time: "03:00 pm",
  },
  {
    id: 3,
    event_name: "10 Takai biriyani in chitagong",
    status: "up-comming",
    location: "chitagong",
    time: "06:00 pm",
  },
  {
    id: 4,
    event_name: "Shisu der jonno amra in Khulna",
    status: "completed",
    location: "Khulna",
    time: "02:00 pm",
  },
  {
    id: 5,
    event_name: "Sobar jonno sikkha in dhaka",
    status: "up-comming",
    location: "Dhaka",
    time: "06:00 pm",
  },
];

export default eventData;
